import { useHistory } from 'react-router-dom';
import { AppUserPage } from '../components/SoloOnboarding/Screens/AppUser';
import { ROUTES } from '../routing';

export default function AppUserUpsell() {
  const history = useHistory();
  return (
    <AppUserPage
      onContinue={() => {
        history.push(ROUTES.PROSUMER.ONBOARDING.getPath());
      }}
    />
  );
}
